import * as styles from '@material-ui/styles';
import defaultTheme from '../themes/website';

function getTheme(theme) {
  // use default theme if none exists or the theme is empty
  return theme && Object.keys(theme).length ? theme : defaultTheme;
}

export function makeStyles(styleFnOrObj, opts) {
  if (typeof styleFnOrObj === 'function')
    return styles.makeStyles(contextTheme => styleFnOrObj(getTheme(contextTheme), opts));
  return styles.makeStyles(styleFnOrObj, opts);
}

export function useTheme() {
  const contextTheme = styles.useTheme();
  return getTheme(contextTheme);
}

export const { ServerStyleSheets } = styles;
